import AdminApp from "./AdminApp";

export default AdminApp;
